import React from 'react';

import { useGetCard } from '@vlabs/api/artemy/client';
import { DetachCardsFromListIconButtonPoint3 } from '@vlabs/monokit/features/detach-cards-from-list';
import { useCardIdFromLocationPoint3 } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { useHasPermission, usePageAccess } from '@vlabs/permissions';
import { useTranslation } from 'react-i18next';

import st from './PersonLists.module.sass';
import { AttachCardToListButton } from '../attach-card-to-list';
import { ListItem } from '../data-items';

const displayName = 'PersonLists';
const testid = buildTestid(displayName);

export function PersonLists(): React.JSX.Element {
  const cardId = useCardIdFromLocationPoint3();
  const { t } = useTranslation();
  const getCard = useGetCard(cardId);
  const canUpdateCard = useHasPermission('card', 'update');
  const canViewListDetails = usePageAccess('lists');
  const cardLists = getCard.data?.lists ?? [];
  const hasLists = cardLists.length > 0;

  return (
    <div
      className={st.Container}
      {...testid()}
    >
      <div className={st.Header}>
        <h6>{t('card-page:features.attach_card_to_list.title')}</h6>

        {!!canUpdateCard && <AttachCardToListButton cardId={cardId} />}
      </div>

      {!!hasLists && (
        <div className={st.List}>
          {cardLists.map((listId) => {
            let actions;
            if (canUpdateCard) {
              actions = (
                <DetachCardsFromListIconButtonPoint3
                  cardId={cardId}
                  fromListId={listId}
                />
              );
            }
            return (
              <ListItem
                actions={actions}
                key={listId}
                linkEnabled={canViewListDetails}
                listId={listId}
              />
            );
          })}
        </div>
      )}

      {!hasLists && (
        <div className={st.Empty}>
          {t('card-page:info.no data')}
        </div>
      )}
    </div>
  );
}
